export const locale = {
  lang: 'pt',
  data: {
    'PERFIL_USUARIO': {
      'TITULO': 'Meu perfil',
      'ENLACES': {
        'configuracion': 'Configurações da conta',
        'notificaciones': 'Notificações de usuário',
        'mensajes': 'Mensagens recebidas'
      },
      'PAGINAS': {
        'configuracion': {
          'TITULO': 'Configurações da conta',
          'OPCIONES': {
            'CAMBIARMAIL': {
              'TITULO': 'Mude o e-mail',
              'SUBTITULO': 'Você pode alterar o endereço de e-mail da sua conta',
              'INPUTS': {
                'MAIL': 'novo endereço de e-mail',
                'TOKEN': 'Código de verificação',
                'PASS': 'Nova Senha',
                'CONFIRMPASS': 'Confirme a Senha'
              },
              'BOTONES': {
                'CAMBIAMAIL': 'Mude o e-mail',
                'VERTOKEN': 'Verifique o código',
                'FINALMAIL': 'Mude o endereço de email',
              }
            },
            'CAMBIARPASS': {
              'TITULO': 'Alterar a senha',
              'SUBTITULO': 'Você pode alterar a senha da sua conta',
              'BOTONES': {
                'FINALPASS': 'Alterar a senha'
              }
            },
            'AUTENTICACION': {
              'TITULO': 'Autenticação de duas etapas',
              'SUBTITULO': 'Você pode aumentar a segurança da sua conta ativando a autenticação em duas etapas',
              'BOTONES': {
                'ACTIVAR': 'Ativar',
                'DESACTIVAR': 'Desativar'
              }
            }
          }
        }
      },
      'MODALES': {
        'CAMBIARMAIL_PASO1_OK': 'Uma mensagem foi enviada para o e-mail especificado com um código de verificação, digite o código de verificação recebido para continuar o processo',
        'CAMBIARMAIL_PASO1_NOTOK': 'Impossível continuar, o email digitado já está cadastrado no sistema',
        'CAMBIARMAIL_PASO1_SAME': 'Não é possível continuar, o e-mail inserido é o mesmo que a conta possui atualmente',
        'CAMBIARMAIL_PASO2_OK': 'O código de verificação está correto, para continuar, você precisa inserir uma nova senha abaixo',
        'CAMBIARMAIL_PASO2_NOTOK': 'O código de verificação está incorreto, verifique se você o inseriu corretamente e verifique novamente',
        'CAMBIARMAIL_PASO3_NOTOK': 'Incapaz de continuar, as senhas não coincidem, por favor digite-as novamente',
        'CAMBIARMAIL_PASO3_OK': 'Os dados da conta foram atualizados corretamente, para finalizar o processo a sessão será encerrada, volte a entrar na plataforma utilizando os novos dados de acesso',
        'CAMBIAPASS_OK': 'A senha da conta foi atualizada com sucesso',
        'CAMBIAPASS_NOTOK': 'Incapaz de continuar, as senhas não coincidem, por favor digite-as novamente',
        'AUTHOK': 'Status de autenticação atualizado com sucesso'
      }
    },
    'PROFILE': {
      'MENU_TITLE':'Fechar     ',
      'MYPROFILLE':'Meu perfil',
      'TITLE':'Mudar senha',
       'BTNBACK':'Costas',
       'MENUTITLE':'Cardápio',
       'MENU':{
         'OPC1':'Meus dados'
       },
       'NAME':'Nome',
       'EMAIL':'O email',
       'CODE':'Código de verificação',
       'NEWPASS':'Nova senha',
       'REPASS':'Redigite a senha',
       'CHANGE':'Mudar senha',
       'SENDCODE':'Enviar código de verificação',
       'CHECKCODE':'Código de verificação',
       'ERROR':{
        'ERROR01':'Required field',
        'ERROR02':'Erro, algo aconteceu',
        'ERROR03':'O código não corresponde',
        'ERROR04':'As senhas não coincidem',
        'ERROR05':'Deve ter no mínimo 3 caracteres',
        'ERROR06':'The email already exits, please try with another one',
        'ERROR07':'O nome da empresa não corresponde '
      },
      'SUCCESS':{
        'OK':'Ok',
       'MESESAGE1':'Dados atualizados corretamente',
       'MESESAGE2':'Código enviado ... Verifique seu e-mail',
       'MESESAGE3':'Correct code'
      }

    },
  }
};
